<!--
 * @Author: qixiao
 * @Date: 2022-09-06 17:24:16
 * @LastEditTime: 2022-09-07 09:25:25
 * @LastEditors: qixiao
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <div class="plate">
        <div class="title">供应商信息</div>
        <el-form
          :model="form"
          :rules="rules"
          ref="form0"
          :inline="true"
          label-width="150px"
          class="form-add"
        >
          <el-form-item class="w100" label="营业执照" prop="license">
            <el-upload
              class="upload-large"
              id="businessLicense"
              :action="'#'"
              accept="image/jpeg,image/gif,image/png"
              :multiple="false"
              :show-file-list="false"
              list-type="picture-card"
              :on-preview="handlePreviewImg"
              :data="{ xtype: 'dv', type: 'image' }"
              :on-success="(file) => handleImgSuccess(file, 'businessLicense')"
              :http-request="handleCustomUpload"
            >
              <img
                v-if="form.businessLicenseUrl == ''"
                class="place-img"
                src="@/assets/upload-bussiness.png"
              />
              <img v-else :src="form.businessLicenseUrl" />
            </el-upload>
            <!-- <p style="color:#F56C6C;font-size:12px;" v-show="form.businessLicenseUrl == '' ">营业执照不能为空</p> -->
          </el-form-item>
          <el-form-item prop="cooperativeType" label="供应商类型">
            <el-select
              v-model="form.cooperativeList"
              placeholder="请选择供应商类型"
              @change="gysTy"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <!-- <el-input placeholder="请输入供应商类型" v-model.trim="form.cooperativeName"></el-input> -->
          </el-form-item>
          <el-form-item prop="cooperativeName" label="供应商名称">
            <el-input
              maxlength="50"
              placeholder="请输入供应商名称"
              v-model.trim="form.cooperativeName"
            ></el-input>
          </el-form-item>
          <el-form-item prop="socialCreditCode" label="统一社会信用代码">
            <el-input
              maxlength="18"
              placeholder="请输入统一社会信用代码"
              v-model.trim="form.socialCreditCode"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="所在地区" prop="areas">
            <el-cascader
              ref="regionCascader"
              :options="regionData"
              :props="regionProps"
              v-model.trim="checkedRegionData"
              placeholder="请选择所在地区"
              @change="szdqChange"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="注册地址">
            <el-input
              placeholder="请输入注册地址"
              maxlength="50"
              v-model.trim="form.address"
            ></el-input>
          </el-form-item>
          <el-form-item label="法人代表" prop="corName">
            <el-input
              placeholder="请输入法人代表"
              maxlength="50"
              v-model.trim="form.corName"
            ></el-input>
          </el-form-item>
          <el-form-item label="注册资本">
            <el-input
              placeholder="请输入注册资本"
              maxlength="50"
              v-model.trim="form.registeredCapitalCh"
            >
            </el-input>
            <!-- <span style="margin-left:10px;">万元</span> -->
          </el-form-item>
          <el-form-item label="成立日期">
            <el-date-picker
              v-model.trim="form.foundingTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择成立日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="营业期限" prop="yyqx">
            <el-input
              v-model.trim="form.businessTerm"
              maxlength="50"
              @change="timeBlur"
              placeholder="例如：2015年01月01日至长期"
            >
            </el-input>
            <!-- <el-date-picker v-model.trim="form.businessTerm" type="daterange" value-format="yyyy-MM-dd"
                            range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期">
                        </el-date-picker> -->
            <!-- <el-date-picker v-show="checked" v-model.trim="form.businessTerm2" type="date"
                            value-format="yyyy-MM-dd" placeholder="请选择开始日期"></el-date-picker> -->
            <!-- <el-checkbox class="longTime" v-model.trim="checked" @change="langs">长期</el-checkbox> -->
          </el-form-item>
        </el-form>
        <el-form
          :model="form"
          :rules="rules"
          ref="form1"
          :inline="false"
          label-width="150px"
          class="form-add"
        >
          <el-form-item label="经营范围">
            <el-input
              style="width: 910px"
              type="textarea"
              placeholder="请输入内容"
              v-model.trim="form.businessScope"
              maxlength="1000"
              show-word-limit
            >
            </el-input>
          </el-form-item>
          <el-form-item label="销售/生产许可证（最多4张）" class="licence">
            <span slot="label"
              >销售/生产许可证 <span class="red_fs">（最多4张）</span></span
            >
            <span class="grayfs"
              >只能上传jpg/png格式文件，文件不能超过50kb</span
            >

            <el-upload
              class="upload-small"
              :action="'#'"
              accept="image/jpeg,image/gif,image/png"
              :multiple="true"
              :show-file-list="true"
              :limit="4"
              list-type="picture-card"
              :file-list="premisesFileList"
              :on-preview="handlePreviewImg1"
              :on-remove="(file) => handleRemoveImg(file, 'premises')"
              :data="{ xtype: 'dv', type: 'image' }"
              :on-success="(file) => handleImgSuccess(file, 'premises')"
              :http-request="handleCustomUpload"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="企业logo" :limit="1" class="licence" prop="logo">
            <span class="grayfs"
              >只能上传jpg/png格式文件，文件不能超过50kb</span
            >
            <el-upload
              class="upload-small"
              :action="'#'"
              accept="image/jpeg,image/gif,image/png"
              :multiple="false"
              :show-file-list="false"
              list-type="picture-card"
              :file-list="logoFileList"
              :on-preview="handlePreviewImg"
              :on-remove="(file) => handleRemoveImg(file, 'logo')"
              :data="{ xtype: 'dv_logo', type: 'image' }"
              :on-success="(file) => handleImgSuccess(file, 'logo')"
              :http-request="handleCustomUpload"
            >
              <!-- <img v-if="form.businessLicenseUrl == ''" class="place-img"
                                src="@/assets/upload-bussiness.png" /> -->
              <i v-if="logoFileList == ''" class="el-icon-plus"></i>
              <img v-else :src="logoFileList" />
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <div class="plate">
        <div class="title">发货信息</div>
        <el-form
          :model="form"
          ref="form2"
          :rules="rules"
          :inline="true"
          label-width="150px"
          class="form-add"
        >
          <el-form-item prop="take" class="w100" label="商品发货地址">
            <el-input
              placeholder="请输入发货详细地址"
              maxlength="100"
              v-model.trim="form.take"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="plate">
        <div class="title">联系人信息</div>
        <el-form
          :model="form"
          ref="form3"
          :rules="rules"
          :inline="true"
          label-width="150px"
          class="form-add"
        >
          <el-form-item prop="userName" label="联系人姓名">
            <el-input
              placeholder="请输入联系人姓名"
              maxlength="30"
              v-model.trim="form.userName"
            ></el-input>
          </el-form-item>
          <el-form-item prop="Phone" label="联系方式">
            <el-input
              placeholder="请输入联系方式"
              maxlength="30"
              v-model.trim="form.Phone"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="plate">
        <div class="title">收款账户信息</div>
        <el-form
          :model="form"
          :inline="true"
          label-width="150px"
          class="form-add"
        >
          <el-form-item label="账户名称">
            <el-input
              placeholder="请输入账户名称"
              maxlength="30"
              v-model.trim="form.accountTitle"
            ></el-input>
          </el-form-item>
          <el-form-item label="银行账号">
            <el-input
              placeholder="请输入银行账号"
              maxlength="30"
              v-model.trim="form.cardNumber"
            ></el-input>
          </el-form-item>
          <el-form-item label="开户行">
            <el-input
              placeholder="请输入开户行"
              maxlength="30"
              v-model.trim="form.deposit"
            ></el-input>
          </el-form-item>
          <el-form-item label="开户行行号">
            <el-input
              placeholder="请输入开户行行号"
              maxlength="18"
              v-model.trim="form.depositNumber"
            ></el-input>
          </el-form-item>
          <el-form-item class="w100" label="备注">
            <el-input
              style="width: 910px"
              type="textarea"
              placeholder="请输入备注"
              maxlength="240"
              show-word-limit
              v-model.trim="form.postScript"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="bottom">
        <!-- <el-button type="info" @click="resetForm('form')">取消</el-button> -->
        <!-- <el-button type="danger" @click="open">删除企业</el-button> -->
        <el-button type="primary" @click="checkForm(refArr)">保存</el-button>
      </div>
    </div>

    <!-- </div> -->
    <el-dialog :visible.sync="previeImgVisible">
      <img width="100%" :src="previewImgUrl" alt="" />
    </el-dialog>
  </el-main>
</template>

<script>
import regionSeatLibs from "utils/regionSeatLibs";
let regionData = JSON.parse(JSON.stringify(regionSeatLibs[0].c));
import { uploadImg } from "@/api/uploadImg";

export default {
  components: {},
  props: [],
  data() {
    const valiMobilePass = (rule, value, callback) => {
      let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!reg.test(value)) {
        callback(new Error("请输入正确的登录手机号"));
      } else {
        callback();
      }
    };
    const validateIdCard = (rule, value, callback) => {
      if (value && value.length != 18) {
        callback(new Error("请输入正确的身份证号"));
      } else {
        callback();
      }
    };
    const validateMobile = (rule, value, callback) => {
      let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (value && !reg.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    var vallidImage = (rule, value, callback, source) => {
      if (!this.form.businessLicenseUrl) {
        callback(new Error("营业执照不能为空"));
      } else {
        callback();
      }
    };
    var validatorYyeqixian = (rule, value, callback, source) => {
      if (!this.form.businessTerm) {
        callback(new Error("营业期限不能为空"));
      } else {
        callback();
      }
    };
    var vallidLogo = (rule, value, callback, source) => {
      if (!this.logoFileList) {
        callback(new Error("企业logo不能为空"));
      } else {
        callback();
      }
    };
    return {
      // 添加营业执照部分
      previewImgUrl: "", //预览图片url
      previeImgVisible: false, //预览图片弹框
      dialogVisible2: false,
      form: {
        cooperativeList: "", //供应商类型
        businessScope: "", //经营范围
        companyId: "", //选择了列表则有
        mobile: "",
        userName: "", //联系人姓名
        Phone: "", //联系方式
        cardNumber: "", //银行账号
        deposit: "", //开户行
        depositNumber: "", //开户行行号
        postScript: "", //备注
        accountTitle: "", //账户名称
        businessZoneId: "",
        businessPersonId: "", //业务员id
        businessLicenseUrl: "", //营业执照url
        cooperativeName: "", //名称
        socialCreditCode: "", //统一社会信用代码
        provinceId: "", //住址省id
        provinceName: "", //住址省name
        cityId: "", //住址市id
        cityName: "", //住址市name
        areaId: "", //所在地区县id
        areaName: "", //所在地区县name
        townId: "", //住址镇乡id
        townName: "", //住址镇乡id
        villageId: "", //住址村id
        villageName: "", //住址村name
        address: "", //住所
        corName: "", //法定代表人
        registeredCapitalCh: "", //出资总额
        foundingTime: "", //成立时
        businessTerm: "", //营业期限
        businessTerm2: "", //营业期限
        directorDto: {
          directorName: "", //理事长姓名
          idCard: "", //身份证号码
          provinceId: "", //住址省id
          provinceName: "", //住址省name
          cityId: "", //住址市id
          cityName: "", //住址市name
          areaId: "", //所在地区县id
          areaName: "", //所在地区县id
          address: "", //住址
          cardPortraitUrl: "", //身份证人像url
          cardEmblemUrl: "", //身份证人像url
          headUrl: "", //头像照片url
          mobile: "", //手机号
        },
        dialogImageUrl: "", //销售/生产许可证url
        take: "", //发货地址
      },
      rules: {
        mobile: [
          { required: true, message: "请输入登录手机号", trigger: "blur" },
          { validator: valiMobilePass, trigger: "blur" },
        ],
        license: [
          {
            required: true,
            message: "营业执照不能为空",
            validator: vallidImage,
            trigger: "change",
          },
        ],
        userName: [
          {
            required: true,
            message: "联系人姓名不能为空",
            trigger: "blur",
          },
        ],
        businessZoneId: [
          {
            required: true,
            message: "请选择业务区域",
            trigger: "change",
          },
        ],
        businessPersonId: [
          {
            required: true,
            message: "请选择业务负责人",
            trigger: "change",
          },
        ],
        cooperativeName: [
          {
            required: true,
            message: "供应商名称不能为空",
            trigger: "change",
          },
        ],
        cooperativeType: [
          {
            required: true,
            message: "供应商类型不能为空",
            trigger: "change",
          },
        ],
        socialCreditCode: [
          {
            required: true,
            message: "统一社会信用代码不能为空",
            trigger: "change",
          },
        ],
        areas: [
          {
            required: true,
            message: "所在地区不能为空",
            trigger: "change",
          },
        ],
        corName: [
          {
            required: true,
            message: "法人代表不能为空",
            trigger: "change",
          },
        ],
        take: [
          {
            required: true,
            message: "发货地址不能为空",
            trigger: "blur",
          },
        ],
        logo: [
          {
            required: true,
            message: "企业logo不能为空",
            trigger: "change",
            validator: vallidLogo,
          },
        ],
        Phone: [
          {
            required: true,
            message: "联系方式不能为空",
            trigger: "blur",
          },
        ],
        yyqx: [
          {
            required: true,
            message: "营业期限不能为空",
            trigger: "change",
            validator: validatorYyeqixian,
          },
        ],
        ["directorDto.idCard"]: { validator: validateIdCard, trigger: "blur" },
        ["directorDto.mobile"]: { validator: validateMobile, trigger: "blur" },
      },
      honorFileList: [], //荣誉图片
      premisesFileList: [], //销售/生产许可证
      logoFileList: "", //logo
      checkedRegionData: [],
      checked: true,
      regionData,
      textarea1: "",
      textarea2: "",
      disabled: false,
      regionProps: {
        value: "i",
        label: "n",
        children: "c",
      },
      options: [
        {
          value: "生资供应商",
          label: "生资供应商",
        },
      ],

      refArr: ["form0", "form1", "form2", "form3"],
      shows: "",
    };
  },
  mounted() {},
  created() {},
  methods: {
    //保存
    checkForm() {
      // this.timeBlur()
      this.form.businessTerm = this.form.businessTerm;
      console.log(this.form);
      const formName = ["form0", "form1", "form2", "form3"];
      const validates = (item) => {
        return new Promise((resolve, reject) => {
          console.log(this.$refs[item]);
          if (!this.$refs[item]) {
            resolve();
            return false;
          }
          this.$refs[item].validate((valid) => {
            if (valid) {
              resolve();
            } else {
              reject(new Error("验证不对"));
            }
          });
        });
      };
      console.log(formName);
      console.log(this.premisesFileList);

      let json = "";
      for (var i = 0; i < this.premisesFileList.length; i++) {
        json += this.premisesFileList[i].url + ",";
      }
      console.log(json);
      Promise.all(formName.map((item) => validates(item)))
        .then(() => {
          let obj = {
            accountName: this.form.accountTitle, //账号名称
            accountNo: this.form.cardNumber, //银行账号
            addr: this.form.take, //详细地址
            bankName: this.form.deposit, //银行名称
            bankNo: this.form.depositNumber, //开户行号
            branchBank: this.form.depositNumber, //开户行支行
            businessTerm: this.form.businessTerm, //营业期限
            businessUrls: this.form.businessLicenseUrl, //营业执照
            enterpriseName: this.form.cooperativeName, //企业名称
            linkPerson: this.form.userName, //联系人
            linkPhone: this.form.Phone, //联系方式
            orgCode: this.form.socialCreditCode, //信用社编码
            orgLegalPerson: this.form.corName, //企业法人
            orgType: this.form.cooperativeList, //企业类型
            registAddr: this.form.address, //注册地址
            registCapital: this.form.registeredCapitalCh, //注册资本
            registTime: this.form.foundingTime, //成立日期
            cname: this.form.cityName, //市name
            cid: this.form.cityId, //市id
            enterpriseLogo: this.logoFileList, //企业LOGO
            oid: this.form.areaId, //县id
            oname: this.form.areaName, //县name
            pid: this.form.provinceId, //省id
            pname: this.form.provinceName, //省name
            productUrls: json, //生产许可证
            remark: this.form.postScript, //备注
            scopes: this.form.businessScope, //经营范围
            registStartTimie: this.form.businessTerm2, //营业期限开始
            registEndTimie: this.form.businessTerm2, //营业期限结束
          };
          // if (form.businessLicenseUrl == '') {
          //     this.$message({
          //         type: 'error',
          //         message: '营业执照不能为空!'
          //     })
          // }
          this.$http.supplierApi.addSupplier(obj).then((res) => {
            console.log(res);
            this.$router.push({ path: "./Success" });
          });
          console.log("成功");
        })
        .catch(() => {
          console.log("失败");
        });
    },
    gysTy(val) {
      console.log(val);
      this.$set(this.form, "cooperativeType", val);
    },
    szdqChange(val) {
      this.$set(this.form, "areas", val);
    },
    yyzzChange(val) {
      console.log(val);
      this.$set(this.form, "license", val);
    },
    timeBlur(val) {
      this.$set(this.form, "yyqx", val);
    },

    //长期

    langs(val) {
      if (this.checked) {
        console.log(this.businessTerm2);
      }
      console.log(val);
    },

    //重置

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    //删除企业

    open() {
      this.$confirm("是否确认删除该企业？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    //预览图片

    handlePreviewImg1(file) {
      console.log(file);
      this.previewImgUrl = file.response ? file.response.url : file.url;
      this.previeImgVisible = true;
    },

    //图片上传成功

    handleImgSuccess(file, type) {
      switch (type) {
        case "businessLicense":
          console.log(file);
          console.log(file.response);

          this.form.businessLicenseUrl = file.url;
          this.disBusinessLicense(file.url);

          const formName = ["form0", "form1", "form2", "form3"];
          const validates = (item) => {
            return new Promise((resolve, reject) => {
              console.log(this.$refs[item]);
              if (!this.$refs[item]) {
                resolve();
                return false;
              }
              this.$refs[item].validate((valid) => {
                if (valid) {
                  resolve();
                } else {
                  reject(new Error("验证不对"));
                }
              });
            });
          };
          Promise.all(formName.map((item) => validates(item)))
            .then(() => {
              let json = [];
              for (var i = 0; i < a.length; i++) {
                json[i] = a[i];
              }
              JSON.stringify(json);
              console.log(json);
              let obj = {
                accountName: this.form.accountTitle, //账号名称
                accountNo: this.form.cardNumber, //银行账号
                addr: this.form.take, //详细地址
                bankName: this.form.deposit, //银行名称
                bankNo: this.form.depositNumber, //开户行号
                branchBank: this.form.depositNumber, //开户行支行
                businessTerm: this.form.businessTerm, //营业期限
                businessUrls: this.form.businessLicenseUrl, //营业执照
                enterpriseName: this.form.cooperativeName, //企业名称
                linkPerson: this.form.userName, //联系人
                linkPhone: this.form.Phone, //联系方式
                orgCode: this.form.socialCreditCode, //信用社编码
                orgLegalPerson: this.form.corName, //企业法人
                orgType: this.form.cooperativeList, //企业类型
                registAddr: this.form.address, //注册地址
                registCapital: this.form.registeredCapitalCh, //注册资本
                registTime: this.form.foundingTime, //成立日期
                cname: this.form.cityName, //市name
                cid: this.form.cityId, //市id
                enterpriseLogo: this.logoFileList, //企业LOGO
                oid: this.form.areaId, //县id
                oname: this.form.areaName, //县name
                pid: this.form.provinceId, //省id
                pname: this.form.provinceName, //省name
                productUrls: this.premisesFileList, //生产许可证
                remark: this.form.postScript, //备注
                scopes: this.form.businessScope, //经营范围
                registStartTimie: this.form.businessTerm2, //营业期限开始
                registEndTimie: this.form.businessTerm2, //营业期限结束
              };
              console.log("成功");
              console.log(file);
            })
            .catch(() => {
              console.log("失败");
            });
          // console.log(this.shows);
          break;
        case "cardPortraitUrl":
          this.form.directorDto.cardPortraitUrl = file.url;
          this.disIdcard(file.url);
          break;
        case "cardEmblemUrl":
          this.form.directorDto.cardEmblemUrl = file.url;
          break;
        case "headUrl":
          this.form.directorDto.headUrl = file.url;
          break;
        case "honor":
          this.honorFileList.push({ url: file.url, name: file.title });
          break;
        case "premises":
          this.premisesFileList.push({ url: file.url, name: file.title });
          break;
        case "logo":
          this.logoFileList = file.url;
          console.log(this.logoFileList);
          break;
      }
      const formName = ["form0", "form1", "form2", "form3"];
      const validates = (item) => {
        return new Promise((resolve, reject) => {
          console.log(this.$refs[item]);
          if (!this.$refs[item]) {
            resolve();
            return false;
          }
          this.$refs[item].validate((valid) => {
            if (valid) {
              resolve();
            } else {
              reject(new Error("验证不对"));
            }
          });
        });
      };
      Promise.all(formName.map((item) => validates(item)))
        .then(() => {
          let json = [];
          for (var i = 0; i < a.length; i++) {
            json[i] = a[i];
          }
          JSON.stringify(json);
          console.log(json);
          let obj = {
            accountName: this.form.accountTitle, //账号名称
            accountNo: this.form.cardNumber, //银行账号
            addr: this.form.take, //详细地址
            bankName: this.form.deposit, //银行名称
            bankNo: this.form.depositNumber, //开户行号
            branchBank: this.form.depositNumber, //开户行支行
            businessTerm: this.form.businessTerm, //营业期限
            businessUrls: this.form.businessLicenseUrl, //营业执照
            enterpriseName: this.form.cooperativeName, //企业名称
            linkPerson: this.form.userName, //联系人
            linkPhone: this.form.Phone, //联系方式
            orgCode: this.form.socialCreditCode, //信用社编码
            orgLegalPerson: this.form.corName, //企业法人
            orgType: this.form.cooperativeList, //企业类型
            registAddr: this.form.address, //注册地址
            registCapital: this.form.registeredCapitalCh, //注册资本
            registTime: this.form.foundingTime, //成立日期
            cname: this.form.cityName, //市name
            cid: this.form.cityId, //市id
            enterpriseLogo: this.logoFileList, //企业LOGO
            oid: this.form.areaId, //县id
            oname: this.form.areaName, //县name
            pid: this.form.provinceId, //省id
            pname: this.form.provinceName, //省name
            productUrls: this.premisesFileList, //生产许可证
            remark: this.form.postScript, //备注
            scopes: this.form.businessScope, //经营范围
            registStartTimie: this.form.businessTerm2, //营业期限开始
            registEndTimie: this.form.businessTerm2, //营业期限结束
          };
          console.log("成功");
          console.log(file);
        })
        .catch(() => {
          console.log("失败");
        });
    },

    //自定义上传

    handleCustomUpload(content) {
      uploadImg(content)
        .then((res) => {
          content.onSuccess(res.data);
          this.$set(this.form, "license", val);
        })
        .catch((err) => {
          content.onError(err);
        });
    },

    //营业执照识别

    disBusinessLicense(imageUrl) {
      let LoadingInstance = this.$loading({
        target: document.getElementById("businessLicense"),
        text: "识别中...",
        background: "rgba(0,0,0,.5)",
      });
      this.$http.common
        .disBusinessLicense({ imageUrl: imageUrl })
        .then((res) => {
          console.log(res);
          LoadingInstance.close();
          let license = res.data.license;
          this.form.cooperativeName = license.name;
          this.form.socialCreditCode = license.reg_num;
          this.form.corName = license.legal_person;
          this.form.address = license.address;
          this.form.registeredCapitalCh = license.capital;
          this.form.foundingTime =
            license.start_date && license.start_date != -1
              ? license.start_date
              : "";
          this.form.businessScope = license.business;
          this.form.businessTerm = license.period;
        })
        .catch(() => {
          LoadingInstance.close();
        });
    },

    // 身份证识别

    disIdcard(imageUrl) {
      let LoadingInstance = this.$loading({
        target: document.getElementById("idCardPortrait"),
        text: "识别中...",
        background: "rgba(0,0,0,.5)",
      });
      this.$http.common
        .disIdcard({ imageUrl: imageUrl })
        .then((res) => {
          LoadingInstance.close();
          let cards = res.data.cards;
          this.form.directorDto.directorName = cards.name;
          this.form.directorDto.idCard = cards.id_num;
          this.form.directorDto.address = cards.address;
        })
        .catch(() => {
          LoadingInstance.close();
        });
    },

    // 根据地区id查询name

    handleRegionName(ids) {
      let province = this.regionData.filter((item) => item.i == ids[0])[0];
      let city = province.c.filter((item) => item.i == ids[1])[0];
      let areaName = ids[2]
        ? city.c.find((item) => item.i == ids[2])
          ? city.c.find((item) => item.i == ids[2]).n
          : ""
        : "";
      return [province.n, city.n, areaName];
    },

    //选择合作社

    selCooperative(row) {
      this.cooperativeCur = row;
      this.dialogVisible = false;
      this.form.companyId = row.id;
      this.form.mobile = row.contact_mobile;
      this.form.cooperativeName = row.company;
      this.form.socialCreditCode = row.credit_code;
      this.form.provinceId =
        row.region_id2 && row.region_id2 != "0" ? row.region_id2 : "";
      this.form.cityId =
        row.region_id3 && row.region_id3 != "0" ? row.region_id3 : "";
      this.form.areaId =
        row.region_id4 && row.region_id4 != "0" ? row.region_id4 : "";
      if (this.form.provinceId) {
        this.checkedRegionData = [this.form.provinceId, this.form.cityId];
        if (this.form.areaId) this.checkedRegionData.push(this.form.areaId);
      }
      console.log(this.form.areaId);

      this.form.address = row.address;
      this.form.corName = row.legal_person;
    },

    //销售/生产许可证

    handleRemoveImg(file, type) {
      switch (type) {
        case "honor":
          this.honorFileList = this.honorFileList.map(
            (item) => item.url != file.url
          );
          break;
        case "premises":
          this.premisesFileList.forEach((item, index) => {
            if (item.url == file.url) {
              this.premisesFileList.splice(index, 1);
            }
          });
          // this.arrS = []
          // this.premisesFileList.forEach(item => {
          //     this.arrS.push(item.url)
          // })
          console.log(this.premisesFileList);
          // this.premisesFileList = this.premisesFileList.map(
          //     (item) => item.url != file.url
          // );
          break;
        case "logo":
          // this.logoFileList = this.premisesFileList.map(
          //     (item) => item.url != file.url
          // );
          console.log(file);
          this.logoFileList = file.url;
          break;
      }
    },
    handlePictureCardPreview(file) {
      this.form.dialogImageUrl = file.url;
      this.dialogVisible2 = true;
    },
    handleDownload(file) {
      console.log(file);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
  },
  watch: {
    checkedRegionData(newVal) {
      this.form.provinceId = newVal[0] || "";
      this.form.cityId = newVal[1] || "";
      this.form.areaId = newVal[2] || "";
      let regionNames =
        newVal.length > 0 ? this.handleRegionName(newVal) : ["", "", ""];
      this.form.provinceName = regionNames[0];
      this.form.cityName = regionNames[1];
      this.form.areaName = regionNames[2];
    },
  },
};
</script>
<style lang="scss"></style>
<style lang="scss" scoped>
.plate {
  .title {
    font-size: 18px;
    color: #333333;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    font-weight: bold;

    label {
      font-size: 16px;
      color: #999999;
    }

    &:before {
      content: "";
      display: inline-block;
      width: 5px;
      height: 18px;
      background: #018388;
      border-radius: 3px;
      margin-right: 5px;
    }
  }
}

::v-deep .el-popup-parent--hidden {
  .el-message-box__status.el-icon-warning {
    color: #fff;
  }
}

.el-form {
  position: relative;
}

.el-form-item {
  position: relative;

  width: 600px;

  .el-input,
  .el-select,
  .el-cascader {
    width: 300px;
  }

  &.w100 {
    width: 100%;
  }
}

::v-deep .el-date-editor.el-input__inner {
  width: 60%;
}

.longTime {
  position: absolute;
  margin-left: 10px;
}

.licence {
  width: 100%;
  margin-top: 20px;
}

.grayfs {
  font-size: 12px;
  color: #ccc;
}

.red_fs {
  color: #f61313;
  font-size: 14px;
}

.bottom {
  width: 100%;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;

  .el-button {
    width: 120px;
  }
}

::v-deep .el-textarea .el-input__count {
  color: #909399;
  background: #ffffff;
  position: absolute;
  font-size: 12px;
  bottom: 5px;
  right: -50px;
}
</style>
